import { useEffect } from 'react';

type RefObject<T> = {
  readonly current: T | null;
};

const useOutsideClick = (ref: RefObject<HTMLDivElement | null>, callback: () => void) => {
  const handleClick = (e: Event) => {
    if (ref.current && !ref.current.contains(e.target as Node)) {
      callback();
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- TODO why are the dependencies not exhaustive?
  }, [ref, callback]);
};

export default useOutsideClick;
